import { usePaginatedQuery, useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import type { TrackState } from '@aeon-karaoke/cloud-convex/model/trackState';
import { useCurrentUser } from './useCurrentUser';

export type { TrackView } from '@aeon-karaoke/cloud-convex/model/trackView';

/** The caller's creations for the manager, optionally one user-facing state.
 * Fifty at a time: a personal list, searched client-side. Skips until the
 * users row exists — querying earlier throws during the sign-in bootstrap
 * window. */
export function useMyTracks(state?: TrackState) {
  const { user } = useCurrentUser();
  return usePaginatedQuery(api.tracks.mine, user ? { state } : 'skip', { initialNumItems: 50 });
}

/** Counts per state plus the titles that failed, for the tabs and the banner. */
export function useMyTracksSummary() {
  const { user } = useCurrentUser();
  return useQuery(api.tracks.mineSummary, user ? {} : 'skip');
}
